import type { BulkMaterialUnitType } from '#domain/BulkMaterialUnitType.ts';

export const CSV_DELIMITER = ';';

export const BULK_UNIT_MAP: Record<string, BulkMaterialUnitType> = {
    kg: 'kilogram',
    kilogram: 'kilogram',
    t: 'ton',
    ton: 'ton',
    l: 'liter',
    liter: 'liter',
    'm^3': 'cubic-meter',
    m3: 'cubic-meter',
    'cubic-meter': 'cubic-meter',
};
